import { type SchemaMarkupItem, serializeSchemaForJsonLd } from '@/utils/schema.utils';
import type { NextPage } from 'next';
import Head from 'next/head';

// https://nextjs.org/docs/messages/no-script-component-in-head
const StructuredData: NextPage<{ data: SchemaMarkupItem }> = ({ data }) => {
  return (
    <Head>
      {/* biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD structured data requires script injection; content is escaped via serializeSchemaForJsonLd */}
      <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: serializeSchemaForJsonLd(data) }} />
    </Head>
  );
};

export default StructuredData;
